import * as React from "react";
import * as Cookies from 'js-cookie';

import {withRouter} from 'react-router';
import {compose} from 'recompose';
import {Unsubscribe, User} from 'firebase';

import {AuthUserContext, withFirebase} from "./index";
import Firebase from "./firebase";
import routes from '../../constants/routes';
import Constants from '../../constants';



interface IProps {
  firebase: Firebase;
  history: any;
}

interface IState {
  user?: User;
}

export const withAuthentication = (Component: any) => {

  class WithAuthentication extends React.Component<IProps, IState> {

    private unsubscribe: Unsubscribe;

    constructor(props: IProps) {
      super(props);
      this.state = {
        user: undefined
      }
    }

    public componentDidMount(): void {
      this.unsubscribe = this.props.firebase.auth.onAuthStateChanged(user => {
        if (!user) {
          this.props.history.push(routes.SIGN_IN);
        } else {
          // save UID and username
          Cookies.set(Constants.uid, user.uid);
          this.setState(() => ({user}));
        }
      })
    }

    public componentWillUnmount(): void {
      this.unsubscribe(); // remove listener
    }

    public render() {
      const { user } = this.state;

      return (
        <AuthUserContext.Provider value={user}>
          <Component {...this.props}/>
        </AuthUserContext.Provider>
      )
    }

  }

  return compose(
    withRouter,
    withFirebase
  )(WithAuthentication);

  // return withFirebase(WithAuthentication);
};

export default withAuthentication;

